<template>
  <MainLoader v-if="loadLoader()" />
  <router-view></router-view>
  <ProductFruitsTestButton />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useUserStore, useThemeStore, useAuthStore } from "@/stores";
import MainLoader from "@/layouts/loader/MainLoader.vue";
import ProductFruitsTestButton from "@/components/common/ProductFruitsTestButton.vue";
import { showLoader } from "./utils/utils";
import { useRoute } from "vue-router";
import { useAppInitiate } from "@/composables/useAppInitiate.ts";
import { initProductFruits } from "./services/productFruits/index.ts";
const user = useUserStore();
const theme = useThemeStore();
const auth = useAuthStore();
const route = useRoute();
const { getHostCompanyData } = useAppInitiate();
const loadLoader = () => {
  return route.name !== "invitation_link_verification";
};

onMounted(async () => {
  /*
   * Initial screen size...
   * Screen size changes catch up here...
   * */
  theme.changeScreenSize(globalThis.innerWidth);
  globalThis.onresize = () => {
    setTimeout(() => {
      theme.changeScreenSize(globalThis.innerWidth);
    }, 100);
  };
  if (globalThis.location.pathname.includes("/appless-")) {
    return false;
  }
  user
    .fetchingUserInfo()
    .then(async () => {
      user.getCompanyUserDetails().finally(async () => {
        showLoader(false);
        await getHostCompanyData();
        user.$state.isCompanyApiExecuting = false;
        // Initialize ProductFruits after user info is loaded
        await initProductFruits();
      });
    })
    .finally(() => {
      user.$state.shouldAuthenticationBegin = true;
      auth.$state.verifyAPIExecuting = false;
    });
});
</script>
